// This is the scss entry file
import "../styles/index.scss";

// We can import Bootstrap JS instead of the CDN link, if you do not use
// Bootstrap, please feel free to remove it.
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";

// Make Bootstrap available globally for inline scripts
window.bootstrap = bootstrap;

// Universal table sorting functionality
import "./table-sort.js";

// Universal table filtering functionality
import "./table-filter.js";

// Searchable owner select functionality
import "./searchable-owner.js";

// GMT offset timezone management
import "./timezone.js";

// Button debouncing functionality
import "./debounce.js";

// Page loading functionality
import "./loading.js";

// Password validation utilities
import "./password-validation.js";

// Clipboard utilities for copy-to-clipboard functionality
import "./clipboard.js";

// Tunnel save confirmation modal for tracking changes
import "./tunnel-save-confirmation.js";

// Initialize Bootstrap tooltips after DOM loads
document.addEventListener('DOMContentLoaded', function() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
});

let typeSelector = document.querySelector('#routing_type');

function nullable(value) {
  return value != '' ? value : null;
}

function updateDisplay(elements, display) {
  elements.forEach(element => element.style.display = display);
}

function updateRoutingFields() {
  let type = nullable(typeSelector.value);

  switch(type) {
    case 'static':
      updateDisplay(document.querySelectorAll('*[data-routing]'), 'block');
      updateDisplay(document.querySelectorAll('*[data-routing-static]'), 'block');
      updateDisplay(document.querySelectorAll('*[data-routing-bgp]'), 'none');
      break;

    case 'bgp':
      updateDisplay(document.querySelectorAll('*[data-routing]'), 'block');
      updateDisplay(document.querySelectorAll('*[data-routing-static]'), 'none');
      updateDisplay(document.querySelectorAll('*[data-routing-bgp]'), 'block');
      break;

    default:
      updateDisplay(document.querySelectorAll('*[data-routing]'), 'none');
      updateDisplay(document.querySelectorAll('*[data-routing-static]'), 'none');
      updateDisplay(document.querySelectorAll('*[data-routing-bgp]'), 'none');
      break;
  }
}

if (typeSelector) {
  typeSelector.addEventListener('change', () => {
    updateRoutingFields();
  });

  updateRoutingFields();
}

let presharedKeySelector = document.querySelector('input[data-generate=preshared-key]');

if (presharedKeySelector) {
  let inputGroup = document.createElement('div');
  inputGroup.className = 'input-group';

  let generateButton = document.createElement('button');
  generateButton.type = 'button';
  generateButton.innerHTML = '<i class="fa fa-rotate">';
  generateButton.className = 'btn btn-light generate';
  generateButton.setAttribute('data-bs-toggle', 'modal');
  generateButton.setAttribute('data-bs-target', '#regeneratePresharedKeyModal');

  let field = presharedKeySelector.parentElement;
  field.parentElement.insertBefore(inputGroup, field);
  inputGroup.appendChild(field);
  inputGroup.appendChild(generateButton);

  // Handle the modal confirm button
  const confirmButton = document.getElementById('confirmRegeneratePresharedKey');
  if (confirmButton) {
    confirmButton.addEventListener('click', (event) => {
      event.preventDefault();

      fetch('/api/v1/generate/wireguard/preshared-key')
        .then((resp) => resp.json())
        .then((resp) => {
          presharedKeySelector.value = resp.key;

          // Close the modal
          const modal = bootstrap.Modal.getInstance(document.getElementById('regeneratePresharedKeyModal'));
          if (modal) {
            modal.hide();
          }

          // Show a toast or alert to remind user to save
          const alertDiv = document.createElement('div');
          alertDiv.className = 'alert alert-success alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3';
          alertDiv.style.zIndex = '9999';
          alertDiv.innerHTML = `
            <i class="fas fa-check-circle me-2"></i>
            <strong>New preshared key generated!</strong> Click "Save Changes" to apply it.
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
          `;
          document.body.appendChild(alertDiv);

          // Auto-dismiss after 5 seconds
          setTimeout(() => {
            alertDiv.remove();
          }, 5000);
        });
    });
  }
}

// Handle regenerate public/private keys
const confirmRegenerateKeysButton = document.getElementById('confirmRegenerateKeys');
if (confirmRegenerateKeysButton) {
  confirmRegenerateKeysButton.addEventListener('click', (event) => {
    event.preventDefault();

    fetch('/api/v1/generate/wireguard/key')
      .then((resp) => resp.json())
      .then((resp) => {
        // Update the public key field
        const publicKeyField = document.getElementById('public_key');
        if (publicKeyField) {
          publicKeyField.value = resp.public;
        }

        // Update the hidden private key field
        const privateKeyField = document.getElementById('private_key');
        if (privateKeyField) {
          privateKeyField.value = resp.private;
        }

        // Close the modal
        const modal = bootstrap.Modal.getInstance(document.getElementById('regenerateKeysModal'));
        if (modal) {
          modal.hide();
        }

        // Show a toast or alert to remind user to save
        const alertDiv = document.createElement('div');
        alertDiv.className = 'alert alert-success alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3';
        alertDiv.style.zIndex = '9999';
        alertDiv.innerHTML = `
          <i class="fas fa-check-circle me-2"></i>
          <strong>New keys generated!</strong> Click "Save Changes" to apply them.
          <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        `;
        document.body.appendChild(alertDiv);

        // Auto-dismiss after 5 seconds
        setTimeout(() => {
          alertDiv.remove();
        }, 5000);
      });
  });
}

